export default __webpack_public_path__ + "static/media/w_mas_2025_a.526aaaf6.jpg";